import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { colorMap } from '../../Common'

const Header = ({ title, description, icon: Icon, buttonText, buttonAction, buttonReturnAction, hasReturn = false, hasAction = false, color = 'indigo' }) => {
    // Mapeamento completo de cores para classes Tailwind


    // Seleciona as classes baseadas na cor fornecida, com fallback para indigo
    const colorClasses = colorMap[color] || colorMap.indigo

    return (
        <div className="bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        {hasReturn && (
                            <button
                                onClick={buttonReturnAction}
                                className="mr-4 p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                                title="Voltar ao painel de cadastros"
                            >
                                <ArrowLeftIcon className="w-5 h-5 text-gray-600" />
                            </button>
                        )}
                        <div className={`p-2 rounded-lg ${colorClasses.headerIconBg} mr-3`}>
                            <Icon className={`w-6 h-6 ${colorClasses.headerIconText}`} />
                        </div>
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900">
                                {title}
                            </h1>
                            <p className="text-sm text-gray-600">
                                {description}
                            </p>
                        </div>
                    </div>
                    {hasAction && (
                        <button
                            onClick={buttonAction}
                            className={`inline-flex items-center px-4 py-2 ${colorClasses.headerButtonBg} text-white rounded-lg ${colorClasses.headerButtonHover} transition-colors duration-200`}
                        >
                            <Icon className="w-4 h-4 mr-2" />
                            {buttonText}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Header